import { useMediaQuery } from "react-responsive";
import { useActiveBannerMessages } from "../components/MessageBanner";

/**
 * @deprecated Should not be used, only used in unreleased guides at the moment
 * @return {number}
 */
export const useHeightOffset = () => {
  const hasBanner = useActiveBannerMessages().length > 0;
  const isMedium = useMediaQuery({ maxWidth: 1199.98 });
  const isSmall = useMediaQuery({ maxWidth: 575.98 });
  const isPrint = useMediaQuery({ query: "print" });
  const bannerHeight = isPrint
    ? 0
    : hasBanner
    ? isSmall
      ? 68
      : isMedium
      ? 54
      : 40
    : 0;
  return bannerHeight;
};
